const initialState = { loading: false, items: [] };

export default function archiveReducer(state = initialState, action) {
	switch (action.type) {
		case "GET_NON_NORMAL_ITEMS_REQUEST":
			return { ...state, loading: true };
		case "GET_NON_NORMAL_ITEMS_SUCCESS":
			return { loading: false, items: action.payload.items };
		case "GET_NON_NORMAL_ITEMS_FAILURE":
			return { loading: false, items: [] };
		default:
			return state;
	}
}
